import { createAction, props } from '@ngrx/store';

export const initialize = createAction(
  '[Payment Link Landing Component] Initialize',
  props<{ paymentLinkToken: string }>(),
);
